module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff?ff13d121c1a1cf74d8e06bd39e1746c3";